import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { VbzButton, VbzInputPassword, VbzAnimation } from '@smiles/voebiz-ui-kit';
import { useTranslation } from 'react-i18next';
import { redirectToHome } from '../../../utils/redirectToHome';
import logoHeaderMobileVoebiz from '../../../assets/voebiz-logo-header-mobile.svg';
import logoHeaderGroupVoebiz from '../../../assets/header-group-logos.svg';

interface INewPassword {
  onFinish: (newPassword: string) => void;
  onGoBack: () => void;
  password: string;
  isLoading?: boolean;
}

const ConfirmPassword: React.FC<INewPassword> = ({ onFinish, onGoBack, password, isLoading = false }) => {
  const { t } = useTranslation('repeat_password');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isValidConfirmPassword, setIsValidConfirmPassword] = useState(true);
  const [isFilled, setIsFilled] = useState<number>(0);
  const [isMobile, setIsMobile] = useState(false);
  const pathHome = useMemo(() => redirectToHome(true), []);

  window.addEventListener('resize', () => {
    if (window.innerWidth < 769) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  });

  useEffect(() => {
    if (window.innerWidth < 769) {
      setIsMobile(true);
    }
  }, [isMobile]);

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.slice(0, 20);
    setIsFilled(value.length >= 8 ? value.length : 0);
    setConfirmPassword(value);
  }, []);

  const handleKeyPressPassword = (e: React.KeyboardEvent) => {
    if (e.key === '.' || e.key === ',' || e.key === '/' || e.key === ';' || e.key === `"`) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    setIsValidConfirmPassword(confirmPassword.length < 8 || password === confirmPassword);
  }, [password, confirmPassword]);

  return (
    <>
      <VbzAnimation
        typeModal="full"
        containerIdLottie="animation-edit-user-issue"
        id="animation-edit-user-issue"
        currentState={{
          isLoading,
          isSuccess: true,
        }}
        finishMode="no"
        message={{
          error: [],
          loading: [`${t('animation_loading')}`],
          success: [],
        }}
      />
      <div className="vbz-new-password">
        <div className="vbz-home-header">
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <a href={pathHome}>
              <span className="vbz-logos">
                <img src={isMobile ? logoHeaderMobileVoebiz : logoHeaderGroupVoebiz} />
              </span>
            </a>
          </div>
        </div>
        <div className="vbz-content">
          <h3>{t('title')}</h3>
          <form>
            <VbzInputPassword
              placeholder="o  o  o  o  o  o  o  o"
              idInput="inp_password"
              idPreviewOn="lbl_previewDisabled"
              idPreviewOff="lbl_previewEnabled"
              idErrorMsg="lbl_msgInvalid_1"
              error={!isValidConfirmPassword && confirmPassword.length >= 4 && password.length <= 20}
              errorMessageList={[t('invalid')]}
              onChange={handleChange}
              onKeyPress={handleKeyPressPassword}
            />
            <div className="vbz-row">
              {(isValidConfirmPassword || confirmPassword.length < 8) && (
                <VbzButton
                  id="btn_continue"
                  isLoading={isLoading}
                  disabled={!isValidConfirmPassword || !isFilled}
                  color="primary"
                  text={t('confirm_password')}
                  onClick={() => onFinish(confirmPassword)}
                />
              )}
              {!isValidConfirmPassword && confirmPassword.length >= 8 && (
                <VbzButton
                  id="btn_anotherPassword"
                  color="hyperlink"
                  text={t('back_to_password_creation')}
                  onClick={onGoBack}
                />
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ConfirmPassword;
